import { render, staticRenderFns } from "./Locations_Main.vue?vue&type=template&id=059c40b1&scoped=true&"
import script from "./Locations_Main.vue?vue&type=script&lang=js&"
export * from "./Locations_Main.vue?vue&type=script&lang=js&"
import style0 from "./Locations_Main.vue?vue&type=style&index=0&id=059c40b1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "059c40b1",
  null
  
)

export default component.exports